import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    overflowY: 'auto',
    scrollBehavior: 'smooth',
    '&::-webkit-scrollbar': {
      width: theme.shape.scrollSize,
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: theme.palette.scroll,
      borderRadius: theme.shape.scrollRadius,
    },
  },
  menuBar: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[3],
    padding: 15,
    cursor: 'pointer',
    marginTop: 1,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  content: {
    padding: 15,
  },
  loadingSection: {
    display: 'flex',
    justifyContent: 'center',
    padding: 15,
  },
  usabilityMask: {
    zIndex: 10,
    width: '100%',
    height: 100,
    position: 'sticky',
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}))

export default useStyles
